// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SignOut: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10.5" viewBox="0 0 12 10.5">
            <path
                fill="#ED1C24"
                d="M2.25,10.5 L3.75,10.5 C4.16484368,10.5 4.5,10.164844 4.5,9.75 C4.5,9.33515596 4.16484368,9 3.75,9 L2.25,9 C1.83585942,9 1.5,8.66414094 1.5,8.25 L1.5,2.25 C1.5,1.83585978 1.83585942,1.5 2.25,1.5 L3.75,1.5 C4.16484368,1.5 4.5,1.16414022 4.5,0.75 C4.5,0.335859776 4.16484368,0 3.75,0 L2.25,0 C1.00734365,0 0,1.00734401 0,2.25 L0,8.25 C0,9.4921875 1.00734365,10.5 2.25,10.5 Z M11.8312497,4.83984375 L8.45390582,1.65234375 C8.29042912,1.49817181 8.05078053,1.45605469 7.84453082,1.54467201 C7.6382103,1.63366413 7.50445247,1.83693767 7.50445247,2.0614686 L7.50230098,3.7489686 L4.50230098,3.748945 C4.08769155,3.748945 3.75183213,4.08480442 3.75183213,4.498945 L3.75183213,5.998945 C3.75183213,6.41308594 4.08792579,6.748945 4.50230098,6.748945 L7.50230098,6.7489686 L7.50445247,8.41537499 C7.50445247,8.63985944 7.6382103,8.84310937 7.84453082,8.93217158 C8.05085135,9.02078891 8.29054642,8.97867179 8.45390582,8.82449985 L11.8312497,5.63699985 C12.0562506,5.44687486 12.0562506,5.05312514 11.8312497,4.83984375 Z"
                opacity=".5"
            />
        </svg>
    );
};

export default React.memo(SignOut);
